import { Paragraph } from '@quickmd-llc/design-system';
import { Button } from '@quickmd-llc/design-system';
import { FormSlideProps } from '../hooks/useRefillCheckup/useRefillCheckupState';
import { useRefillCheckup } from '../hooks/useRefillCheckup';

export function ButtonForm({ question }: Pick<FormSlideProps, 'question'>) {
  const { toggleCheckupFailed, nextSlide } = useRefillCheckup();
  return (
    <>
      <Paragraph className="mb-6 flex-1 font-semibold">{question}</Paragraph>
      <Button
        className="mb-4"
        onClick={toggleCheckupFailed}
        priority="secondary"
        size="m"
      >
        Yes
      </Button>
      <Button onClick={nextSlide} priority="secondary" size="m">
        No
      </Button>
    </>
  );
}
